'use client';

import { useIsLaptop } from '@/_hooks/useBreakpoint';
import { IRedux } from '@/_store/types';
import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Button, IconButton } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLEAR, TOGGLE_CHECKOUT } from '@/_store/cart/cart.slice';
import ConfirmModal from '@/_components/ConfirmModal';
import { useRouter } from '@/i18n/navigation';
import { BrandCartList, EmptyCartState } from './components';
import { useActiveBrand } from '@/_hooks/useActiveBrand';
import cartIcon from '@/shared/assets/svg/cart-bold-white.svg';
import Image from 'next/image';
import { getBrandHref } from '@/_lib/brand-href';

const CartPopover = () => {
  const [open, setOpen] = useState(false);
  const [isClearOpen, setClearOpen] = useState(false);

  const cart = useSelector(
    (state: IRedux) => state.cart.cart,
  );

  const t = useTranslations();
  const dispatch = useDispatch();
  const isLaptop = useIsLaptop();
  const router = useRouter();
  const shipperId = useActiveBrand()

  const handleClear = (shipperId: string) => {
    if (shipperId) {
      dispatch(CLEAR({ shipper_id: shipperId }));
    } else {
      setClearOpen(true);
    }
  };

  const handleBrandCheckout = (brand: string) => {
    dispatch(TOGGLE_CHECKOUT({ shipper_id: shipperId }));
    router.push(getBrandHref(brand, { path: '/checkout' }));
  };

  const handleBrandRestaurant = (brand: string) => {
    // Restaurant holatiga o'tkazish (isCheckout: false)
    dispatch(TOGGLE_CHECKOUT({ shipper_id: shipperId }));
    router.push(getBrandHref(brand));
  };

  return (
    <>
      <PopoverRoot
        open={open}
        onOpenChange={(e) => setOpen(e.open)}
        positioning={{ placement: 'bottom-end', offset: { mainAxis: 8 } }}
      >
        <PopoverTrigger asChild>
          {isLaptop ? (
            <IconButton
              aria-label={t('cart')}
              title={t('cart')}
              bg='primary'
              color='primary.text'
              _hover={{ bg: 'primary.hover' }}
              rounded='full'
              size='xl'
            >
              <Image src={cartIcon} alt='cart' width={24} height={24} />
            </IconButton>
          ) : (
            <Button
              bg='primary'
              color='primary.text'
              _hover={{ bg: 'primary.hover' }}
              rounded='full'
              size='xl'
            >
              <Image src={cartIcon} alt='cart' width={24} height={24} />
              {t('cart')}
            </Button>
          )}
        </PopoverTrigger>
        <PopoverContent
          p={0}
          w={'346px'}
          rounded={16}
          maxH={'80vh'}
          bg={'background.card'}
        >
          <PopoverBody p={0}>
            {cart && Object.values(cart)?.some((value) => value?.products?.length > 0) ? (
              <BrandCartList
                cart={cart}
                onClear={handleClear}
                onCheckout={handleBrandCheckout}
                onRestaurant={handleBrandRestaurant}
                onClosePopover={() => setOpen(false)}
              />
            ) : (
              <EmptyCartState onClose={() => setOpen(false)} />
            )}
          </PopoverBody>
        </PopoverContent>
      </PopoverRoot>
      <ConfirmModal
        title={t('clear_cart')}
        isOpen={isClearOpen}
        onClose={() => setClearOpen(false)}
        onConfirm={() => {
          dispatch(CLEAR({ shipper_id: shipperId }));
          setClearOpen(false);
        }}
      />
    </>
  );
};

export default CartPopover;
